<template>
    <div v-if="project != null" class="container mb-5">
      <h1 class="mt-4 mb-5 text-center">{{ project.title }}</h1>
      <div class="row" v-if="!editmode">
      <!-- Carousel -->
        <div class="col-md-8">
          <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img class="d-block w-100" src="https://placehold.it/1920x1080" alt="First slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="https://placehold.it/1920x1080" alt="Second slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="https://placehold.it/1920x1080" alt="Third slide">
            </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div class="container mt-5" v-html="project.description">{{project.description}}</div>
        <button @click="editmode = !editmode">Modifica</button>
      </div>
      <!-- Description -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            Utenti presenti nel Team
          </div>
          <ul class="list-group list-group-flush">
            <li v-for="user in project.users" class="list-group-item">{{ user.name }}</li>
          </ul>
        </div>
        <img class="mt-5" src="https://placehold.it/350x350"></img>
      </div>
    </div>

    <!-- <div class="row mt-4 mb-5">
      <div class="col-md-8">
         Utenti che hanno contribuito

      </div>
      <div class="col-md-4">

      </div>
      <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        Materiali acquistati
                    </div>
                    <ul class="list-group list-group-flush">
                        <li v-for="material in project.materials" class="list-group-item">{{ material.name }}</li>
                    </ul>
                </div>
            </div> 
       Corsi acquistati
    </div>-->
    <h3 class="mb-3" v-if="!editmode">Corsi acquistati</h3>
    <div class="row" v-if="!editmode">
      <div v-for="course in project.courses" class="col-md-4 mb-3">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{{ course.name }}</h5>
            <h6 class="card-subtitle mb-2 text-muted" v-if="course.teacher">{{ course.teacher }}</h6>
            <h6 class="card-subtitle mb-2 text-muted" v-else>Nessun insegnante registrato</h6>
            <p class="card-text">{{ course.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="editor" class="container mt-5" v-if="editmode">
     <quill-editor :config="editorOption" v-model="project.description"></quill-editor>
    </div>
    <input v-if="editmode" v-model="project.isPrivate" type="checkbox" class="form-check-input" id="projectIsPrivate">
    <label v-if="editmode" class="form-check-label" for="projectIsPrivate">Privato</label>
    <button v-if="editmode" @click="update">Save</button>
  </div>
</template>

<script>
import { convertDate } from "@/helpers";
import { database } from "@/firebase";
import { quillEditor } from 'vue-quill-editor'

export default {
  name: "UserProjectDetail",
  data() {
    return {
      project: null,
      editorOption: {},
      editmode: false
    }
  },
  methods:{
    update: function(){
      console.log(this.project.description)
      database.collection("Projects").doc(this.$route.params.id).update({title: this.project.title, description: this.project.description, isPrivate:this.project.isPrivate})
      this.editmode = false;
    }
  },
  components:{
    quillEditor
  },
  created() {
    console.log("partito" + this.$route.params.id)
    database.collection("Projects").doc(this.$route.params.id)
    .get()
    .then(doc => {
      // Project setup
      console.log(doc.data())
      var project = doc.data()
      let cDate = convertDate(project.creationDate)
      project.creationDate = cDate
      let uDate = convertDate(project.lastUpdate)
      project.lastUpdate = uDate
      project.showMore = false        
      project.users = []
      // Project user list setup
      project.team.get().then(doc => {
        console.log(doc.data())
        doc.data().users.forEach(user => {
          user.get().then(userDoc => {
            project.users.push(userDoc.data());
            this.project = project
            console.log(this.project)
          })
        })
      })
      this.project = project
    })
  }
}
</script>

<style scoped>
.project__title small {
  font-size: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/UserProjectDetail.vue